import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { dashboardQueries } from '../queries/dashboardQueries';
import { DASHBOARD_RSIM_STATUS, getRSimStatus } from '../api/DashboardApi';
import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { getPieColors } from 'src/common/components/Graphs/common/Graphs/utils/doughnut';
import { setMinimalPromiseTime } from 'src/common/utils/setMinimalPromiseTime';

type UseRSimStatusDataProps = {
  accountRef: string;
};

export const useRSimStatus = ({ accountRef }: UseRSimStatusDataProps) => {
  const { palette } = useTheme();
  const { t } = useTranslation();

  const { data } = useSuspenseQuery({
    queryKey: dashboardQueries.rSimStatus({ accountRef }),
    queryFn: () => setMinimalPromiseTime(getRSimStatus({ accountRef })),
  });

  const rSimStatusData = useMemo(
    () => ({
      labels: [
        t('dashboard.rSimStatusChart.legend.primary'),
        t('dashboard.rSimStatusChart.legend.backup'),
        t('dashboard.rSimStatusChart.legend.disconnected'),
      ],
      dataset: {
        data: [
          data.data[DASHBOARD_RSIM_STATUS.PRIMARY],
          data.data[DASHBOARD_RSIM_STATUS.BACKUP],
          data.data[DASHBOARD_RSIM_STATUS.DISCONNECTED],
        ],
        ...getPieColors([palette.blue, palette.green, palette.red]),
      },
    }),

    [t, data],
  );

  return { total: data.total, chartData: rSimStatusData };
};
